import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen, Globe2, GraduationCap } from "lucide-react";

export const AuthShell = ({ eyebrow, title, subtitle, children }) => {
  return (
    <div className="min-h-screen bg-white grid lg:grid-cols-2">
      {/* Left visual */}
      <div className="hidden lg:flex relative overflow-hidden bg-brand-navy p-12 flex-col justify-between text-white">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-brand-red/40 blur-3xl animate-blob" />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-brand-gold/25 blur-3xl animate-blob" style={{ animationDelay: "5s" }} />
        <div
          className="absolute inset-0 opacity-[0.05]"
          style={{
            backgroundImage: "radial-gradient(circle at 20% 30%, #fff 1px, transparent 1px)",
            backgroundSize: "36px 36px",
          }}
        />

        <div className="relative">
          <Link to="/" data-testid="auth-back-home" className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm font-semibold">
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
        </div>

        <div className="relative">
          <motion.div
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
            className="flex items-center gap-3"
          >
            <div className="w-12 h-12 rounded-2xl bg-brand-red grid place-items-center font-black text-2xl">L</div>
            <div>
              <div className="font-heading font-black text-2xl">Language Nest India</div>
              <div className="text-[11px] uppercase tracking-[0.25em] text-brand-gold">Speak · Score · Soar</div>
            </div>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3, duration: 0.9 }}
            className="mt-10 font-heading font-black text-4xl leading-tight max-w-md"
          >
            5,000+ students trusted us with their <span className="text-brand-gold">global dreams.</span>
          </motion.p>

          <div className="mt-10 flex gap-3 flex-wrap">
            {[
              { Icon: BookOpen, label: "IELTS · PTE" },
              { Icon: GraduationCap, label: "Study Abroad" },
              { Icon: Globe2, label: "27+ Countries" },
            ].map(({ Icon, label }) => (
              <div key={label} className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur border border-white/15 text-sm font-semibold">
                <Icon className="w-4 h-4 text-brand-gold" /> {label}
              </div>
            ))}
          </div>
        </div>

        <div className="relative text-white/60 text-sm">
          A-30, Nanda Rd, Adarsh Nagar, Delhi 110033 · +91 93821 66788
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 md:p-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="w-full max-w-md"
        >
          <div className="lg:hidden mb-8">
            <Link to="/" className="inline-flex items-center gap-2 text-brand-navy/60 hover:text-brand-red text-sm font-semibold">
              <ArrowLeft className="w-4 h-4" /> Back to home
            </Link>
          </div>

          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-red">{eyebrow}</div>
          <h1 className="mt-2 font-heading font-black text-3xl md:text-4xl text-brand-navy leading-tight">{title}</h1>
          {subtitle && <p className="mt-3 text-brand-navy/60">{subtitle}</p>}

          <div className="mt-8">{children}</div>
        </motion.div>
      </div>
    </div>
  );
};
